import { getCardBalance } from 'common/api/wallet/cards';
import { useApi } from 'common/modules/async-actions/useApi';
import { useEffect } from 'react';
import { Card } from 'common/api/e-comm/models/Card';

export const useCardBalance = (card?: Card | null) => {
    const [doGetCardBalance, getCardBalanceAsyncState, getCardBalanceResult] =
        useApi(getCardBalance);

    useEffect(() => {
        if (card?.id && card?.settings?.canCheckBalance) {
            (async () => {
                await doGetCardBalance(card.id as string);
            })();
        }
    }, [card, doGetCardBalance]);

    return {
        isLoading: getCardBalanceAsyncState.loading,
        error: getCardBalanceAsyncState.error,
        data: getCardBalanceResult?.data,
    };
};
